import { useState } from "react";
import { toast } from "react-hot-toast";
import { uploadFileTemporary } from "../../../../api/borrowerPortal/uploadFile.js";

const uid = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

export function useBtlUploads(initialUploads = {}) {
  const [uploads, setUploads] = useState(initialUploads || {});
  const [uploadingFiles, setUploadingFiles] = useState({});

  const handleUpload = (bucketKey, fieldname) => async (files) => {
    if (!files?.length) return;
    const nextBucket = [...(uploads[bucketKey] || [])];

    for (const file of files) {
      const uploadId = uid();
      const fileName = file.name || "Unknown file";
      setUploadingFiles((prev) => ({
        ...prev,
        [bucketKey]: [...(prev[bucketKey] || []), { id: uploadId, name: fileName, progress: 0 }],
      }));

      try {
        const up = await uploadFileTemporary({
          file,
          isPrivate: true,
          onProgress: (percent) => {
            if (typeof percent === "number" && percent < 100) {
              setUploadingFiles((prev) => ({
                ...prev,
                [bucketKey]: (prev[bucketKey] || []).map((u) =>
                  u.id === uploadId ? { ...u, progress: percent } : u
                ),
              }));
            }
          },
        });
        await new Promise((r) => setTimeout(r, 200));
        nextBucket.push({
          id: uid(),
          file_url: up?.file_url,
          file_name: up?.file_name,
          name: up?.name,
          _temp: true,
          _fieldname: fieldname,
        });
      } catch (error) {
        console.error("Upload error:", error);
        toast.error(`Failed to upload ${fileName}`);
      } finally {
        setUploadingFiles((prev) => ({
          ...prev,
          [bucketKey]: (prev[bucketKey] || []).filter((u) => u.id !== uploadId),
        }));
      }
    }

    setUploads((prev) => ({ ...prev, [bucketKey]: nextBucket }));
  };

  const handleRemove = (bucketKey) => (fileId) => {
    setUploads((prev) => ({
      ...prev,
      [bucketKey]: (prev[bucketKey] || []).filter((f) => f.id !== fileId && f.name !== fileId),
    }));
  };

  return { uploads, setUploads, uploadingFiles, handleUpload, handleRemove };
}
